import React, { useState } from 'react';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    position: "fixed",
    bottom: 0,
    paddingBottom: "10px",
    left: "10px",
    zIndex: 1000,
  }
}));

const StickyButton = ({content,toggleComponent,toggleContent}) => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <Box
      className={classes.buttonContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Button
        variant="outlined"
        color="primary"
        onClick={() =>toggleComponent(toggleContent)}
        className={classes.button}
        sx={{borderRadius:"40px",transition: "border-radius 0.3s ease-out"}}
        style={{ opacity: isHovered ? 1 : 0.5 }}
      >
        {content}
      </Button>
    </Box>
  );
};

export default StickyButton;
